import { ProjectsOverview } from "@/components/projects/projects-overview.tsx";
import { m } from "@/paraglide/messages.js";
import { projectsStatsQueryOptions } from "@/services/projects-service.ts";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/dashboard/projects/")({
	component: RouteComponent,
	loader: ({ context: { queryClient } }) => {
		queryClient.prefetchQuery(projectsStatsQueryOptions());
	},
	head: () => ({
		meta: [{ title: pageTitle(m.projects_title()) }],
	}),
});

function RouteComponent() {
	return <ProjectsOverview />;
}
